if (!customElements.get('venja-card-rail')) {
  class VenjaCardRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-venja-card-track]');
      this.cards = Array.from(this.querySelectorAll('[data-venja-card]'));
      this.nextButton = this.querySelector('[data-venja-card-next]');
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.currentIndex = 0;
      this.scrollFrame = null;

      if (!this.track || this.cards.length < 2 || !this.nextButton) return;

      this.handleNext = () => this.goTo(this.currentIndex + 1);
      this.handleScroll = () => {
        if (this.scrollFrame) return;

        this.scrollFrame = window.requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updateFromScroll();
        });
      };
      this.handleResize = () => {
        if (!this.mobileQuery.matches) {
          this.currentIndex = 0;
          this.updateControl();
          return;
        }

        this.updateFromScroll();
      };

      this.nextButton.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize);
      this.updateControl();
    }

    disconnectedCallback() {
      if (!this.track || !this.handleNext) return;

      this.nextButton.removeEventListener('click', this.handleNext);
      this.track.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);

      if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
    }

    goTo(index) {
      const nextIndex = Math.max(0, Math.min(index, this.cards.length - 1));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const trackLeft = this.track.getBoundingClientRect().left;
      const cardLeft = this.cards[nextIndex].getBoundingClientRect().left;

      this.track.scrollTo({
        left: this.track.scrollLeft + cardLeft - trackLeft,
        behavior: reducedMotion ? 'auto' : 'smooth'
      });

      this.currentIndex = nextIndex;
      this.updateControl();
    }

    updateFromScroll() {
      if (!this.mobileQuery.matches) return;

      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;
      const trackLeft = this.track.getBoundingClientRect().left;

      this.cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      this.currentIndex = closestIndex;
      this.updateControl();
    }

    updateControl() {
      this.nextButton.disabled = this.currentIndex === this.cards.length - 1;
    }
  }

  customElements.define('venja-card-rail', VenjaCardRail);
}
